import React, { useState } from 'react';

const Faqs = () => {
    // Sample FAQ data - replace with your actual data
    const faqData = [
        {
            id: 1,
            category: "Ordering & Shipping",
            questions: [
                {
                    id: "faq1",
                    question: "Do you offer international shipping?",
                    answer: "Yes, we offer international shipping options. Shipping costs and delivery times may vary based on the destination."
                },
                {
                    id: "faq2",
                    question: "How can I track my order?",
                    answer: "Once your order ships, you will receive a confirmation email with tracking information so you can monitor your shipment’s progress."
                },
                {
                    id: "faq3",
                    question: "Do you have a physical store location?",
                    answer: "Currently, we operate online only. However, our customer service team is available to assist you with any inquiries or concerns."
                },
                {
                    id: "faq4",
                    question: "Can I purchase products in bulk?",
                    answer: "Absolutely! We encourage bulk purchases and offer discounts for larger orders. Please reach out to our customer service team for more information."
                },
                {
                    id: "faq5",
                    question: "How long does it take to process and ship my order?",
                    answer: "Orders are typically processed within 1-2 business days. Delivery times vary depending on your location and the shipping method selected."
                },
                {
                    id: "faq6",
                    question: "What shipping carriers do you use?",
                    answer: "We use reliable carriers such as UPS, FedEx, DHL, and USPS to ensure your order reaches you quickly and safely."
                },
                {
                    id: "faq7",
                    question: "Can I change or cancel my order after it's placed?",
                    answer: "If your order hasn’t been processed or shipped yet, please contact us immediately and we’ll do our best to accommodate changes or cancellations."
                },
                {
                    id: "faq8",
                    question: "Do you offer free shipping?",
                    answer: "We offer free standard shipping on orders over a certain amount. Please check our website or promotions page for current offers."
                }
            ]
        },
        {
            id: 2,
            category: "Returns & Refunds",
            questions: [
                {
                    id: "faq9",
                    question: "What should I do if I receive a damaged or incorrect item?",
                    answer: "If you receive a damaged or incorrect item, please contact our customer service immediately. We will guide you through the return or exchange process to resolve the issue promptly."
                },
                {
                    id: "faq10",
                    question: "What is your return policy?",
                    answer: "We accept returns within 30 days of the delivery date. Items must be unused, in original packaging, and in resellable condition to be eligible for a refund or exchange."
                },
                {
                    id: "faq11",
                    question: "How do I initiate a return?",
                    answer: "To start a return, contact our customer support with your order number and the reason for return. We’ll provide the return shipping instructions."
                },
                {
                    id: "faq12",
                    question: "When will I receive my refund?",
                    answer: "Refunds are processed within 5–7 business days after we receive and inspect the returned product. Refunds are issued to the original method of payment."
                },
                {
                    id: "faq13",
                    question: "Can I exchange an item instead of returning it?",
                    answer: "Yes, we do allow exchanges for eligible items. Reach out to our support team to process your exchange request."
                }
            ]
        },
        {
            id: 3,
            category: "Product Information",
            questions: [
                {
                    id: "faq14",
                    question: "What types of automotive products do you sell?",
                    answer: "You can use our parts finder tool by entering your vehicle make, model, and year. Each product page also lists compatibility information. If you're still unsure, feel free to contact our support team for assistance."
                },
                {
                    id: "faq15",
                    question: "Do you carry products for all vehicle types?",
                    answer: "Yes, we provide products suitable for cars, trucks, SUVs, vans, and even boats. Our inventory covers a wide range of vehicle makes and models."
                },
                {
                    id: "faq16",
                    question: "Are your products easy to install?",
                    answer: "Most of our products are designed for easy installation and come with clear instructions. If you have questions about a specific product, feel free to contact our customer service."
                },
                {
                    id: "faq17",
                    question: "Do you offer warranties on your products?",
                    answer: "Yes, we offer warranties on many of our products. Warranty details can usually be found on the product page or packaging."
                },
                {
                    id: "faq18",
                    question: "How do I know if a product is right for my vehicle?",
                    answer: "You can check the product descriptions for compatibility details. If you’re unsure, please contact us with your vehicle's make and model, and we’ll assist you in finding the right product."
                },
                {
                    id: "faq19",
                    question: "Are your products OEM or aftermarket?",
                    answer: "We carry high-quality aftermarket products that meet or exceed OEM standards to ensure reliability and performance."
                },
                {
                    id: "faq20",
                    question: "Can I find installation guides or videos on your site?",
                    answer: "Yes, we provide detailed installation guides and videos for many products to make installation as easy as possible."
                },
                {
                    id: "faq21",
                    question: "Are your products safe for all weather conditions?",
                    answer: "Many of our products are built to withstand various weather conditions. Specific product pages will mention if they are weather-resistant or all-season friendly."
                },
                {
                    id: "faq22",
                    question: "Do your products meet industry safety standards?",
                    answer: "Yes, all of our products are tested and compliant with applicable industry safety and quality standards."
                },
            ]
        },
        {
            id: 4,
            category: "Account & Payment",
            questions: [
                {
                    id: "faq23",
                    question: "What payment methods do you accept?",
                    answer: "We accept various payment methods, including major credit cards, PayPal, and other secure options available at checkout."
                },
                {
                    id: "faq24",
                    question: "How can I stay updated on new products and promotions?",
                    answer: "You can sign up for our newsletter to receive updates on new arrivals, special promotions, and exclusive offers."
                },
                {
                    id: "faq25",
                    question: "Do I need an account to place an order?",
                    answer: "No, you can check out as a guest. However, creating an account allows you to track orders, save shipping addresses, and receive exclusive deals."
                },
                {
                    id: "faq26",
                    question: "Is my payment information secure?",
                    answer: "Yes. We use advanced encryption and secure payment gateways to protect your personal and financial information."
                },
                {
                    id: "faq27",
                    question: "Can I use multiple payment methods for one order?",
                    answer: "At this time, we only support one form of payment per transaction."
                },
                {
                    id: "faq28",
                    question: "How do I reset my account password?",
                    answer: "Click on “Forgot Password” at the login screen and follow the instructions sent to your registered email to reset your password."
                }
            ]
        }
    ];

    const customRedColor = "#ed1c24";

    // State to track active category and open accordion items
    const [activeCategory, setActiveCategory] = useState(faqData[0].id);
    const [activeAccordion, setActiveAccordion] = useState(null);

    // Custom function to handle accordion clicks
    const handleAccordionClick = (faqId) => {
        setActiveAccordion(activeAccordion === faqId ? null : faqId);
    };

    // Custom CSS styles
    const styles = {
        customRedBtn: {
            backgroundColor: customRedColor,
            borderColor: customRedColor,
            color: "white"
        },
        customRedOutlineBtn: {
            color: customRedColor,
            borderColor: customRedColor,
            backgroundColor: "transparent"
        },
        customRedOutlineBtnHover: {
            backgroundColor: customRedColor,
            color: "white"
        },
        accordionButtonActive: {
            color: customRedColor,
            fontWeight: "600",
            backgroundColor: "#fff"
        },
        accordionButtonInactive: {
            color: "#212529",
            backgroundColor: "#f8f9fa"
        }
    };

    return (
        <div className="faq-container">
            <div className="container py-4 mb-5">
                <div className="row">
                    {/* Category Pills with custom red color */}
                    <div className="col-lg-3 mb-4">
                        <div className="faq-categories" style={{ top: '2rem' }}>
                            <h5 className="mb-3 fw-bold">Categories</h5>
                            <div className="d-flex flex-column gap-2">
                                {faqData.map(category => (
                                    <button 
                                        key={category.id}
                                        className={`btn`}
                                        style={activeCategory === category.id ? styles.customRedBtn : styles.customRedOutlineBtn}
                                        onClick={() => setActiveCategory(category.id)}
                                        onMouseOver={(e) => {
                                            if (activeCategory !== category.id) {
                                                e.currentTarget.style.backgroundColor = styles.customRedOutlineBtnHover.backgroundColor;
                                                e.currentTarget.style.color = styles.customRedOutlineBtnHover.color;
                                            }
                                        }}
                                        onMouseOut={(e) => {
                                            if (activeCategory !== category.id) {
                                                e.currentTarget.style.backgroundColor = styles.customRedOutlineBtn.backgroundColor;
                                                e.currentTarget.style.color = styles.customRedOutlineBtn.color;
                                            }
                                        }}
                                    >
                                        {category.category}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* FAQ Accordions with manual open/close control */}
                    <div className="col-lg-9">
                        {faqData.filter(category => category.id === activeCategory).map(category => (
                            <div key={category.id} className="mb-4">
                                <h2 className="h3 mb-4 fw-bold">{category.category}</h2>
                                <div className="accordion">
                                    {category.questions.map((faq) => (
                                        <div className="accordion-item border mb-3 shadow-sm" key={faq.id}>
                                            <h3 className="accordion-header m-0">
                                                <button 
                                                    className={`accordion-button ${activeAccordion === faq.id ? '' : 'collapsed'}`}
                                                    type="button" 
                                                    onClick={() => handleAccordionClick(faq.id)}
                                                    style={activeAccordion === faq.id ? styles.accordionButtonActive : styles.accordionButtonInactive}
                                                >
                                                    {faq.question}
                                                </button>
                                            </h3>
                                            <div 
                                                className={`accordion-collapse ${activeAccordion === faq.id ? 'show' : 'collapse'}`}
                                            >
                                                <div className="accordion-body">
                                                    <p className="mb-0">{faq.answer}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}

                        {/* More Help Section with custom red color */}
                        <div className="mt-5 p-4 bg-light rounded-3 text-center">
                            <h3 className="fw-bold">Still have questions?</h3>
                            <p className="mb-4">Our customer support team is here to help.</p>
                            <div className="d-flex justify-content-center gap-3">
                                <a href="/contact-us" className="btn text-white" style={{ backgroundColor: customRedColor }}>
                                    <i className="bi bi-chat-dots me-2"></i>Contact Us
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add custom CSS for accordion styling */}
            <style jsx>{`
                .accordion-button:not(.collapsed) {
                    color: ${customRedColor};
                    background-color: #fff;
                    box-shadow: none;
                }
                
                .accordion-button:not(.collapsed)::after {
                    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23${customRedColor.substring(1)}'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
                    transform: rotate(-180deg);
                }
            `}</style>
        </div>
    );
};

export default Faqs;